export default __webpack_public_path__ + "static/media/stock-photo-fresh-blueberries-removebg-preview.b3ee6fa2.png";